import { render, staticRenderFns } from "./notVoteComponent.vue?vue&type=template&id=71deeb7d&scoped=true"
import script from "./notVoteComponent.vue?vue&type=script&lang=js"
export * from "./notVoteComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71deeb7d",
  null
  
)

export default component.exports